import React, { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const WhoWeAre = () => {
  const [isMissionOpen, setMissionOpen] = useState(false);
  const [isVisionOpen, setVisionOpen] = useState(false);
  const [isValuesOpen, setValuesOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          } else {
            setIsVisible(false);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section className={`who-we-are py-5 ${isVisible ? "fade-in" : "fade-out"}`} ref={sectionRef}>
      <div className="container">
        <div className="row align-items-center">

          <div className="col-lg-6 text-start slide-in-left">
            <span className="approach-indicator">• Notre Approche</span>
            <h2 className="fw-bold">
              Des solutions innovantes pour la{" "}
              <span className="text-success">réussite</span>{" "}
              <span className="text-danger">de votre entreprise</span>
            </h2>
            <p className="justified-text">
              Transformez votre entreprise avec des solutions adaptées à vos défis uniques.
              Nous mettons à profit l'innovation et l'expertise pour optimiser vos processus.
            </p>


            <div className="section-toggle" onClick={() => setMissionOpen(!isMissionOpen)}>
              <h4 className="fw-bold">Notre Mission</h4>
              {isMissionOpen ? <FaChevronUp className="toggle-icon" /> : <FaChevronDown className="toggle-icon" />}
            </div>
            {isMissionOpen && (
              <p className="section-content justified-text">
                Notre mission repose sur 04 axes fondamentalement:

                Promouvoir la création d'entreprises
                Satisfaire les besoins en services d'expertise comptable des entreprises par secteur d'activités
                Accompagner les entreprises à la croissance
                Simplifier la gestion financière de nos clients et leur permettre de se concentrer sur leur cœur de métier, grâce à notre expertise et notre engagement.

              </p>
            )}


            <div className="section-toggle" onClick={() => setVisionOpen(!isVisionOpen)}>
              <h4 className="fw-bold">Notre Vision</h4>
              {isVisionOpen ? <FaChevronUp className="toggle-icon" /> : <FaChevronDown className="toggle-icon" />}
            </div>
            {isVisionOpen && (
              <p className="section-content justified-text">
                La Vision partagée par l'ensemble de l'Equipe de CINEF-EC est d'Être un acteur majeur de la réussite de nos clients, être reconnu comme un cabinet qui permet à ses clients de s'épanouir financièrement et d'atteindre leurs objectifs à long terme en leur apportant une valeur ajoutée significative et en contribuant au développement de l'économie nationale.<br/>

                Être reconnu comme un cabinet qui permet à nos clients de s'épanouir financièrement et d'atteindre leurs objectifs à long terme.
              </p>
            )}


            <div className="section-toggle" onClick={() => setValuesOpen(!isValuesOpen)}>
              <h4 className="fw-bold">Nos Valeurs</h4>
              {isValuesOpen ? <FaChevronUp className="toggle-icon" /> : <FaChevronDown className="toggle-icon" />}
            </div>
            {isValuesOpen && (
              <p className="section-content justified-text">
                Expertise et Professionnalisme :
                Nous nous engageons à maintenir un haut niveau d'expertise et de professionnalisme dans toutes nos interventions.<br/>

                Confiance et Intégrité :
                "Nous agissons avec transparence, honnêteté et dans le respect de la déontologie de notre profession."<br/>

                Engagement Client :
                Nous construisons des relations durables avec nos clients, basées sur la proximité, la compréhension de leurs enjeux et un accompagnement sur mesure.<br/>

                Innovation et Adaptabilité :
                "Nous faisons preuve d'agilité et d'adaptabilité pour accompagner nos clients dans un environnement en perpétuel changement."<br/>

                Esprit d'Équipe et Collaboration :
                Nous favorisons un environnement de travail collaboratif et valorisons l'esprit d'équipe au sein de notre cabinet et,
                Nous travaillons en étroite collaboration avec nos clients pour atteindre leurs objectifs communs.


              </p>
            )}
          </div>


          <div className="col-lg-6 position-relative text-center slide-in-right">
            <div className="image-container">
              <img
                src="../assets/images/image15.png"
                alt="Réunion d'équipe"
                className="main-img img-fluid rounded shadow"
              />
              <img
                src="../assets/images/image16.png"
                alt="Consultation"
                className="sub-img img-fluid rounded shadow"
              />
            </div>
          </div>
        </div>
      </div>


      <style>{`
        
        .fade-in {
          opacity: 1;
          transform: translateY(0);
          transition: opacity 1s ease-in-out, transform 1s ease-in-out;
        }

        .fade-out {
          opacity: 0;
          transform: translateY(20px);
          transition: opacity 1s ease-in-out, transform 1s ease-in-out;
        }

        .who-we-are {
          opacity: 0;
          transform: translateY(20px);
        }

        
        .slide-in-left {
          transform: translateX(-50px);
          opacity: 0;
          transition: transform 1s ease-in-out, opacity 1s ease-in-out;
        }

        .slide-in-right {
          transform: translateX(50px);
          opacity: 0;
          transition: transform 1s ease-in-out, opacity 1s ease-in-out;
        }

        .fade-in .slide-in-left,
        .fade-in .slide-in-right {
          transform: translateX(0);
          opacity: 1;
        }

        .approach-indicator {
          color: #e63946;
          font-weight: bold;
        }

        .justified-text {
          text-align: justify;
        }

        .section-toggle {
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          border-top: 1px solid #ddd;
          padding-top: 15px;
          margin-top: 15px;
        }

        .toggle-icon {
          font-size: 20px;
          color: #e63946;
          transition: 0.3s;
        }

        
        .image-container {
          position: relative;
          max-width: 400px;
          margin: auto;
        }

        .main-img {
          width: 100%;
          border: 5px solid white;
        }

        .sub-img {
          position: absolute;
          bottom: -20px;
          right: -30px;
          width: 60%;
          border: 5px solid white;
        }
      `}</style>
    </section>
  );
};

export default WhoWeAre;
